module.exports = __webpack_public_path__ + "img/selected3-min.ac30b366.png";